import { useState } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { FOUNDATION } from "@/data/content";
import { toast } from "sonner";
import { LogIn, ArrowLeft } from "lucide-react";
import { getImageUrl } from "@/lib/api";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Memuat...</div>;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Login berhasil");
      navigate("/admin", { replace: true });
    } else {
      setError(res.error || "Login gagal");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f8f5ee] via-white to-[#e7edfb] flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-[var(--brand-blue)] mb-8">
          <ArrowLeft className="h-4 w-4" /> Kembali ke situs
        </Link>
        <div className="card-sf p-8 md:p-10">
          <div className="flex items-center gap-3 mb-8">
            <img src={getImageUrl(FOUNDATION.logo)} alt="Sauyunan" className="h-12 w-12" />
            <div>
              <div className="text-lg font-bold tracking-tight text-[var(--brand-blue)]">SAUYUNAN</div>
              <div className="text-[10px] font-semibold uppercase tracking-[0.22em] text-[var(--brand-orange)]">CMS Panel</div>
            </div>
          </div>
          <h1 className="text-3xl font-bold text-slate-900 mb-2">Masuk ke Panel Admin</h1>
          <p className="text-sm text-slate-600 mb-8">Kelola berita, galeri, program, publikasi, dan submissions.</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-1.5">Email</label>
              <input
                data-testid="admin-login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm focus:outline-none focus:border-[var(--brand-blue)]"
                placeholder="admin@sauyunan.org"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-1.5">Password</label>
              <input
                data-testid="admin-login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm focus:outline-none focus:border-[var(--brand-blue)]"
              />
            </div>

            {error && (
              <div data-testid="admin-login-error" className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg p-3">{error}</div>
            )}

            <button
              type="submit"
              disabled={submitting}
              data-testid="admin-login-submit"
              className="btn-secondary w-full justify-center"
            >
              <LogIn className="h-4 w-4" /> {submitting ? "Memproses..." : "Masuk"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
